module.exports = __webpack_public_path__ + "img/icon-bulk-WHATSAPP-gray.8652e89c.svg";